import { i18n } from 'i18next';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import { State } from 'redux/initialState';

import { Society, User } from 'types';

import { isSocietyConstituted } from 'modules/society/utils/society';
import menuOptions from 'modules/partners/pages/PartnerList/utils/menuOptions';
import operationTypes from 'constants/operationTypes';

const getFilteredOptions = (society: Society, i18n: i18n, user: User) => {
  if (!society) {
    return [];
  }

  const partnersCount = society?.partnersCount?.total || 0;
  const sharesCount = society?.sharesCount?.actual || 0;
  const currentMenuOptions = menuOptions(i18n, user);

  if (partnersCount === 0) {
    const [addPartnerOption, constitutionOption] = currentMenuOptions;
    return [addPartnerOption, constitutionOption];
  }

  if (sharesCount === 0) {
    const [addPartnerOption, constitutionOption, capitalIncreaseOption] =
      currentMenuOptions;

    return [
      addPartnerOption,
      isSocietyConstituted(society)
        ? capitalIncreaseOption
        : constitutionOption,
    ];
  }

  return currentMenuOptions.filter(
    (option) => option.type !== operationTypes.CONSTITUTION
  );
};

export const useGetOperationsMenu = () => {
  const { i18n } = useTranslate();

  const user = useSelector((state: State) => state.user);
  const society = useSelector((state: State) => state?.society?.actualSociety);

  const data = useMemo(
    () => getFilteredOptions(society, i18n, user),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [society, i18n.language, user]
  );

  return { data };
};
